var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pushhike-optin" }, [
    _c("div", { staticClass: "pushhike-optin__content" }, [
      _c(
        "div",
        {
          staticClass: "js-pushhike-title-desc-container",
          staticStyle: { display: "flex", "align-items": "flex-start" },
          attrs: { dir: "auto" }
        },
        [
          _c("div", { staticStyle: { flex: "1" } }, [
            _c(
              "h2",
              {
                staticClass: "js-pushhike-title pushhike-optin__title",
                attrs: { tabindex: "-1" }
              },
              [_vm._v(" " + _vm._s(_vm.config.title) + " ")]
            ),
            _c(
              "p",
              {
                staticClass:
                  "js-pushhike-description pushhike-optin__description"
              },
              [_vm._v(" " + _vm._s(_vm.config.description) + " ")]
            )
          ])
        ]
      ),
      _c("div", { staticClass: "pushhike-optin__footer" }, [
        _c(
          "div",
          {
            staticClass:
              "pushhike-optin__footer-btn-wrap js-pushhike-btn-container",
            attrs: { dir: "auto" }
          },
          [
            _c(
              "button",
              {
                staticClass:
                  "js-pushhike-no-button pushhike-optin__button pushhike-optin__no-button"
              },
              [_vm._v(" " + _vm._s(_vm.config.noButton.label) + " ")]
            ),
            _c(
              "button",
              {
                staticClass:
                  "js-pushhike-yes-button pushhike-optin__button pushhike-optin__yes-button"
              },
              [_vm._v(" " + _vm._s(_vm.config.yesButton.label) + " ")]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }